import { create } from "zustand";
import { v4 as uuidv4 } from "uuid";

const useNotificationStore = create((set) => ({
  notifications: [], // NotificationShape[] — ordered newest-first

  // Replace the entire notifications list with persisted records from the backend.
  // Called once on login. Backend returns newest-first; shape is normalised here.
  hydrate: (serverNotifications) => {
    const normalised = serverNotifications.map((n) => ({
      id: n.notification_id ?? n.id,
      timestamp: n.timestamp ? new Date(n.timestamp).getTime() : Date.now(),
      read: n.read ?? false,
      category: n.category ?? null,
      message: n.message ?? null,
      navigateTo: n.navigate_to ?? null,
    }));
    set({ notifications: normalised });
  },
  addNotification: (partial) => {
    const notification = {
      id: uuidv4(),
      timestamp: Date.now(),
      read: false,
      navigateTo: null,
      ...partial,
    };
    set((state) => ({
      notifications: [notification, ...state.notifications],
    }));
  },

  markRead: (id) =>
    set((state) => ({
      notifications: state.notifications.map((n) =>
        n.id === id ? { ...n, read: true } : n
      ),
    })),

  markAllRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, read: true })),
    })),

  removeNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),

  clearAll: () => set({ notifications: [] }),
}));

export default useNotificationStore;
